import { createBrowserRouter } from 'react-router';
import { RootLayout } from './components/RootLayout';
import { Layout } from './components/Layout';
import { Dashboard } from './pages/Dashboard';
import { NewAnalysis } from './pages/NewAnalysis';
import { ProjectDetails } from './pages/ProjectDetails';
import { RiskAnalysisPage } from './pages/RiskAnalysisPage';
import { FinancingPage } from './pages/FinancingPage';
import { ProfileSettings } from './pages/ProfileSettings';
import { Billing } from './pages/Billing';
import { Admin } from './pages/Admin';
import { Login } from './pages/Login';
import { Signup } from './pages/Signup';
import { VerifyEmail } from './pages/VerifyEmail';
import { ForgotPassword } from './pages/ForgotPassword';
import { ResetPassword } from './pages/ResetPassword';
import { TermsOfService } from './pages/TermsOfService';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { PaymentSuccess } from './pages/PaymentSuccess';
import { ErrorBoundary } from './components/ErrorBoundary';
import { NotFound } from './pages/NotFound';

export const router = createBrowserRouter([
  {
    path: '/',
    Component: RootLayout,
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: 'login',
        Component: Login,
      },
      {
        path: 'signup',
        Component: Signup,
      },
      {
        path: 'verify-email',
        Component: VerifyEmail,
      },
      {
        path: 'forgot-password',
        Component: ForgotPassword,
      },
      {
        path: 'reset-password',
        Component: ResetPassword,
      },
      {
        path: 'terms-of-service',
        Component: TermsOfService,
      },
      {
        path: 'privacy-policy',
        Component: PrivacyPolicy,
      },
      {
        path: 'payment-success',
        Component: PaymentSuccess,
      },
      {
        path: '',
        element: <Layout />,
        children: [
          {
            index: true,
            Component: Dashboard,
          },
          {
            path: 'new',
            Component: NewAnalysis,
          },
          {
            path: 'project/:id',
            Component: ProjectDetails,
          },
          {
            path: 'project/:id/risk-analysis',
            Component: RiskAnalysisPage,
          },
          {
            path: 'project/:id/financing',
            Component: FinancingPage,
          },
          {
            path: 'profile-settings',
            Component: ProfileSettings,
          },
          {
            path: 'billing',
            Component: Billing,
          },
          {
            path: 'admin',
            Component: Admin,
          },
          {
            path: '*',
            Component: NotFound,
          },
        ],
      },
    ],
  },
]);